export default "__VITE_ASSET__Dtw5rEzw__"